import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ServiceWorkerState, State } from './service-worker.model';

export const selectServiceWorkerState = createFeatureSelector< ServiceWorkerState>('serviceWorker');

export const selectIsServiceWorkerUpdateModalOpen = createSelector(
    selectServiceWorkerState,
    state => state.isServiceWorkerUpdateModalOpen
);
